export default __webpack_public_path__ + "static/media/ar-g.b281ebf2.svg";